import type { FormProps } from "antd"
import { Form, message } from "antd"
import Title from "antd/es/typography/Title"
import { t } from "i18next"
import React, { useState } from "react"
import "react-quill/dist/quill.snow.css"
import { useNavigate } from "react-router"
import { Paths } from "~/constants"
import FeaturedImage from "~/modules/post/pages/FeaturedImage"
import { useUiBuilder } from "~/modules/ui-builder/services/ui-builder"
import { FieldType, MediaData } from "~/types/types"
import baseService from "../service/base"
import BaseForm from "./BaseForm"
import Publish from "./Publish"

const AddNewBase = () => {
  const [quillValue, setQuillValue] = React.useState<string>("")
  const [form] = Form.useForm()
  const [status, setStatus] = useState("Draft")
  const [isUIBuilderPage, setIsUIBuilderPage] = useState(false)
  const navigate = useNavigate()
  const { addBase, checkSlug } = baseService()
  const [selectedMetaImage, setSelectedMetaImage] = useState<MediaData | null>(null)
  const [publishDate, setPublishDate] = useState<string | null>(null)
  const [selectedImage, setSelectedImage] = useState<MediaData | null>(null)
  const [language, setLanguages] = useState("vi")
  const baseServices = baseService()

  const { createNewBlockContent } = useUiBuilder()

  const dataPayload = {
    name: "",
    email: "",
    hotline: "",
    workingTime: "",
    address: "",
    latitude: "",
    longitude: "",
    linkMap: "",
    linkPost: "",
    publishedAt: status === "Draft" ? null : new Date().toISOString(),
    image: selectedImage,
    isUseUIBuilder: isUIBuilderPage,
    locale: language,
  }

  const onFinish: FormProps<FieldType>["onFinish"] = async values => {
    const dataPayload = {
      name: values.name,
      email: values.email,
      hotline: values.hotline,
      workingTime: values.workingTime,
      address: values.address,
      latitude: values.latitude,
      longitude: values.longitude,
      linkMap: values.linkMap,
      linkPost: values.linkPost,
      publishedAt: status === "Draft" ? null : new Date().toISOString(),
      image: selectedImage,
      isUseUIBuilder: isUIBuilderPage,
      locale: language,
    }

    try {
      const createdBase = await baseServices.addBase({ data: dataPayload })

      if (isUIBuilderPage) {
        const createdBlockContent = await createNewBlockContent({ base: createdBase.data.id })
        navigate(`/ui-builder/${createdBlockContent.data.id}`)
        return
      }

      message.success(t("Base added successfully!"))

      form.resetFields()

      navigate(Paths.BASESYSTEM.LIST.PATH)
    } catch (error) {
      message.error(t("Failed to add base. Please try again."))
    }
  }

  const onFinishFailed: FormProps<FieldType>["onFinishFailed"] = () => {}

  const onChangeMetaImage = (media: MediaData | null) => {
    setSelectedMetaImage(media)
  }

  const handleSelectMedia = (media: MediaData | null) => {
    setSelectedImage(media)
  }

  return (
    <div className="p-4">
      <Title level={2} className="m-0">
        {t("Add New Base")}
      </Title>
      <div className="flex justify-between">
        <BaseForm
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          quillValue={quillValue}
          setQuillValue={setQuillValue}
          onChangeMetaImage={onChangeMetaImage}
          isUIBuilderPage={isUIBuilderPage}
          base={dataPayload}
        />
        <div className="w-[22%] pt-2">
          <Publish
            onPageTypeChanged={isUseUIBuilder => {
              setIsUIBuilderPage(isUseUIBuilder)
            }}
            onSubmit={form.submit}
            isCreateEdit={true}
            setStatus={setStatus}
            status={status}
            setPublishDate={setPublishDate}
            language={language}
            setLanguages={setLanguages}
          />
          <FeaturedImage selectedMedia={selectedImage} setSelectedMedia={handleSelectMedia} />
        </div>
      </div>
    </div>
  )
}

export default AddNewBase
